import { makeStyles } from '@material-ui/core'
import GrinScanTooltip from 'components/Patients/Timeline/V2/MiniTimeline/GrinScanTooltip'
import useScanOralScore from 'components/Patients/Timeline/V2/useScanOralScore'
import React, { useCallback, useRef, useState } from 'react'
import { useFetchTrackedScanTimelineItemQuery } from 'store/modules/TxTrackingReport'
import { trackEvent } from 'utils/analyticsUtils'
import TrackStatusIcon from './TrackStatusIcon'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    cursor: 'pointer'
  }
}))

/**
 * One of a row's last tracked scans. Hovering it loads the scan's timeline item and opens the same
 * scan tooltip Patient Copilot shows.
 */
const TrackedScanIcon = ({ patientId, trackedScan, onTrackReasonsClick }) => {
  const classes = useStyles()
  const anchorRef = useRef()
  const [isHovered, setIsHovered] = useState(false)
  const [wasHovered, setWasHovered] = useState(false)
  const [hoverStartTime, setHoverStartTime] = useState(null)

  const { data: timelineItem } = useFetchTrackedScanTimelineItemQuery(
    { patientId, scanUniqueId: trackedScan.scanUniqueId },
    { skip: !wasHovered || !trackedScan.scanUniqueId }
  )
  const oralScores = useScanOralScore({ oralScores: timelineItem?.payload?.oralScores })

  const handleMouseEnter = useCallback(() => {
    setIsHovered(true)
    setWasHovered(true)
    setHoverStartTime(new Date().getTime())
  }, [])

  const handleMouseLeave = useCallback(() => {
    setIsHovered(false)

    const totalSecondsWasOpen = (new Date().getTime() - hoverStartTime) / 1000
    if (totalSecondsWasOpen > 0.2) {
      trackEvent('Tx Tracking Report - Scan hover', {
        patientId,
        trackStatus: trackedScan.trackStatus,
        totalSecondsWasOpen
      })
    }
  }, [hoverStartTime, patientId, trackedScan.trackStatus])

  return (
    <div className={classes.root} ref={anchorRef} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {timelineItem && (
        <GrinScanTooltip
          anchorEl={anchorRef.current}
          isOpen={isHovered}
          date={timelineItem.eventDate}
          scanNumber={timelineItem.payload?.scanNumber}
          alignerNumber={timelineItem.payload?.alignerNumber}
          scans={timelineItem.payload?.scans}
          scanType={timelineItem.payload?.scanType}
          urgency={timelineItem.payload?.urgency}
          trackStatus={timelineItem.payload?.trackStatus || trackedScan.trackStatus}
          oralScores={oralScores}
          rawOralScores={timelineItem.payload?.oralScores}
          onTrackReasonsClick={onTrackReasonsClick}
          placement="bottom"
        />
      )}
      <TrackStatusIcon trackStatus={trackedScan.trackStatus} />
    </div>
  )
}

export default TrackedScanIcon
